import React, { Fragment } from 'react'
import DefaultAvatar from "../images/default_avatar.jpg"




const NewChatUser = ({ user, newUserID, setNewUserID, setNewUserData, setConversationID, isOnline }) => {


    return (
        <Fragment>
            <div 
                className={`flex gap-[1vmax] items-center p-[0.8vmax] rounded-lg cursor-pointer transition-all mb-[0.3vmax] border
                    ${newUserID === user?.id ? "bg-indigo-50/70 border-indigo-100" : "hover:bg-gray-50 border-transparent"}`}
                onClick={() => {
                    setNewUserID(prev => prev === user?.id ? null : user?.id);
                    setNewUserData(prev => prev?.id === user?.id ? {} : user);
                    setConversationID(null);
                }}
            >
                <div className="relative w-[2.5vmax] h-[2.5vmax] flex-shrink-0">
                    <div className="w-full h-full rounded-full overflow-hidden border border-gray-100 shadow-sm bg-white">
                        <img src={user?.avatar_url || DefaultAvatar} alt={user?.name} className="w-full h-full object-cover" />
                    </div>
                    {isOnline && (
                        <div className="absolute bottom-0 right-0 w-[0.7vmax] h-[0.7vmax] rounded-full bg-emerald-500 border-2 border-white"></div>
                    )}
                </div>

                {/* Info */}
                <div className="flex-1 min-w-0">
                    <div className="flex justify-between items-baseline">
                        <h3 className={`text-[0.95vmax] font-bold truncate ${newUserID === user?.id ? "text-indigo-700" : "text-gray-800"}`}>
                            {user?.name}
                            <span className='text-[0.75vmax] font-medium text-gray-500 ml-[0.5vmax]'>({user?.role})</span>
                        </h3>
                        <div className={`text-indigo-600 transition-opacity ${newUserID === user?.id ? "opacity-100" : "opacity-0"}`}>
                            <i className="fa-solid fa-circle-check text-[1.1vmax]"></i>
                        </div>
                    </div>
                    <p className='text-[0.8vmax] text-gray-500 mt-[0.1vmax]'>User ID: {user?.id}</p>
                </div>
            </div>
        </Fragment>
    )
}

export default NewChatUser
